import { defineMessages } from 'react-intl-next';

export default defineMessages({
	insertMenuTriggerLabel: {
		id: 'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel',
		defaultMessage: 'Insert rich content',
		description: 'Label for the button that opens the insert menu',
	},
	insertMenuAddLink: {
		id: 'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink',
		defaultMessage: 'Add link',
		description:
			'Label for a drop-down menu item that allows the user to insert a smart link into the editor. "Add link" means the action of adding a hyperlink to the content.',
	},
	insertMenuMention: {
		id: 'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention',
		defaultMessage: 'Mention user',
		description:
			'Label for a menu item in a drop-down insert menu that allows the user to mention or tag another user in the document. Selecting this option triggers a user search to insert an @mention.',
	},
	promptRecord: {
		id: 'fabric.editor.ai.screens.prompt.streaming.record',
		defaultMessage: 'Record',
		description: 'Accessible label for the microphone button',
	},
	promptSubmit: {
		id: 'fabric.editor.ai.screens.prompt.streaming.submit',
		defaultMessage: 'Submit',
		description: 'Accessible label for the send/submit button',
	},
	promptPlaceholder: {
		id: 'fabric.editor.ai.screens.prompt.streaming.placeholder',
		defaultMessage: 'Describe what you want to do',
		description: 'Placeholder hint displayed while the prompt input field is empty',
	},
	inlineCommentPromptPlaceholder: {
		id: 'fabric.editor.ai.screens.prompt.streaming.inlineCommentPlaceholder',
		defaultMessage: 'Describe what to do',
		description:
			'Placeholder hint displayed while the prompt input field is empty for inline comment',
	},
});
